import React from 'react';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';

interface Props {
  routeLink: string;
  errors: string[];
}

export const EMPTY_BILLING_PROFILE_WARNING_MESSAGES = {
  noPaymentMethod: 'No payment method available for the billing profile',
  noSoldToAddress: 'No sold-to address available for the billing profile',
};

export const EmptyBillingProfileWarningPanel = ({ routeLink, errors }: Props) => {
  return (
    <SectionMessage
      title="Update billing profile"
      appearance="warning"
      actions={[
        <SectionMessageAction key="billing" href={routeLink}>
          Add information to billing profile
        </SectionMessageAction>,
      ]}
    >
      <p>Subscription changes can't be made because there's:</p>
      <br />
      {errors.map((error, index) => (
        <p key={`error-${index}`}>{error}</p>
      ))}
      <br />
      <p>
        Add the information or switch the billing profile, then try again. Still having trouble? Contact the{' '}
        <strong>#help-advocate-central</strong> channel
      </p>
    </SectionMessage>
  );
};
